<template>
    <div class="con">
<!--        <banComponent :img="info.img" :text0="info.text0" :text1="info.text1"></banComponent>-->
        <div class="banner">
            <img :src="info.img" alt="">
            <div class="text animated fadeInUp">
                <p>{{$t('cy').text0}}</p>
                <p>
                    {{$t('cy').text1}}<br>{{$t('cy').text2}}
                </p>
            </div>
            <div class="scr">
                <span>scrool</span>
                <span></span>
            </div>
        </div>
        <div class="main">
            <div class="nav" :class="{'enNav':$i18n.locale === 'en'}">
                <span v-for="(item,index) in $t('cy').navList" :key="index" :class="{'showLine':select===index}" @click="change(index)">{{item}}</span>
            </div>
        </div>
        <div class="all">

            <transition name="fade">
                <div class="one" v-if="select===0">
                    <div class="gy wow fadeInUp">
                        <img src="../assets/cy/a.png" alt="">
                        <div class="right">
                            <p>{{$t('cy').navList[0]}}</p>
                            <dia-Component class="a"></dia-Component>
                        </div>
                    </div>
                    <div class="module">
                     <p class="title wow fadeInUp">{{$t('cy').text3}}</p>
                        <div class="content wow fadeInUp">
                         <div class="item" v-for="(item,index) in mList" :key="index">
                             <router-link :to="{path: 'proInfo',query:{id:item.ID,index:select}}" target="_blank">
                              <p>{{item.PRONAME}}</p>
                             <p>{{item.ZY}}</p>
                             <span>{{$t('cy').text5}}</span>
                             </router-link>
                         </div>
                        </div>
                        <div style="width:100%;text-align: center;margin-top:60px">
                            <span>{{$t('about').text2}}</span>
                            <div @click="showMore">
                                <btn-Component></btn-Component>
                            </div>
                        </div>
                    </div>
                    <div class="map wow fadeInUp">
                        <div class="m">
                            <map-Component  style="width:100%;"></map-Component>
                            <p>
                                {{$t('cy').text8[0]}}<br>
                                {{$t('cy').text8[1]}}<br>
                                {{$t('cy').text8[2]}}
                            </p>
                        </div>
                        <img src="../assets/about/phmp.png" alt="">
                    </div>
                    <div class="table wow fadeInUp">
                        <img src="../assets/cy/ta.png" alt="">
                    </div>
                    <div class="company">
                        <p class="title wow fadeInUp">{{$t('cy').text8[3]}}</p>
                        <div class="allImg">
                            <div class="item" v-for="(item,index) in imgList" :key="index">
                                <img :src="item.img" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="two" v-if="select===1">
                    <div class="fir">
                        <img src="../assets/cy/l.png" alt="">
                        <div class="right">
                            <p>{{$t('cy').navList[1]}}</p>
                            <diasy-Component class="a"></diasy-Component>
                        </div>
                    </div>
                    <div class="module">
                        <p class="title">{{$t('cy').text4}}</p>
                        <div class="content">
                            <div class="item" v-for="(item,index) in mList" :key="index">
                                <router-link :to="{path: 'proInfo',query:{id:item.ID,index:select}}" target="_blank">
                                <p>{{item.PRONAME}}</p>
                                <p>{{item.ZY}}</p>
                                <span>{{$t('cy').text5}}</span>
                                </router-link>
                            </div>
                        </div>
                        <div style="width:100%;text-align: center;margin-top:60px" >
                            <span>{{$t('about').text2}}</span>
                            <div @click="showMore">
                                <btn-Component></btn-Component>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="two" v-if="select===2">
                    <div class="fir">
                        <img src="../assets/cy/tz.png" alt="">
                        <div class="right">
                            <p>{{$t('cy').navList[2]}}</p>
                            <diatz-Component class="a"></diatz-Component>
                        </div>
                    </div>
                    <div class="module">
                        <p class="title">{{$t('cy').text6}}</p>
                        <div class="content">
                            <div class="item" v-for="(item,index) in mList" :key="index">
                                <router-link :to="{path: 'proInfo',query:{id:item.ID,index:select}}" target="_blank">
                                <p>{{item.PRONAME}}</p>
                                <p>{{item.ZY}}</p>
                                <span>{{$t('cy').text5}}</span>
                                </router-link>
                            </div>
                        </div>
                        <div style="width:100%;text-align: center;margin-top:60px" >
                            <span>{{$t('about').text2}}</span>
                            <div @click="showMore">
                                <btn-Component></btn-Component>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="two" v-if="select===3">
                    <div class="fir">
                        <img src="../assets/cy/jz.png" alt="">
                        <div class="right">
                            <p>{{$t('cy').navList[3]}}</p>
                            <diajz-Component class="a"></diajz-Component>
                        </div>
                    </div>
                    <div class="module">
                        <p class="title">{{$t('cy').text7}}</p>
                        <div class="content">
                            <div class="item" v-for="(item,index) in mList" :key="index">
                                <router-link :to="{path: 'proInfo',query:{id:item.ID,index:select}}" target="_blank">
                                <p>{{item.PRONAME}}</p>
                                <p>{{item.ZY}}</p>
                                <span>{{$t('cy').text5}}</span>
                                </router-link>
                            </div>
                        </div>
                        <div style="width:100%;text-align: center;margin-top:60px">
                            <span>{{$t('about').text2}}</span>
                            <div @click="showMore">
                                <btn-Component></btn-Component>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import  banComponent from '../components/tbanner'
    import  mapComponent from '../components/map'
    import  btnComponent from '../components/btn'
    import footComponent from '../components/foot'
    import  diaComponent from '../components/aboutDia'
    import  diasyComponent from '../components/aboutDiasy'
    import  diatzComponent from '../components/aboutDiatz'
    import  diajzComponent from '../components/aboutDiajz'
    import '../common/jquery-1.11.3.min'
    import Scrollbar from 'smooth-scrollbar'
    import {getProductsUrl} from '../util/lang'
    export default {
        name: "cy",
        data(){
            return{
                imgList2:[
                    {url:require('../assets/cy/a.png')},
                    {url:require('../assets/cy/sy.jpg')},
                    {url:require('../assets/cy/sy.jpg')},
                    {url:require('../assets/cy/sy.jpg')}
                ],
                id:'',
                page:'',
                totalPage:'',
                imgList:[
                    {img:require('../assets/cy/1.png')},
                    {img:require('../assets/cy/2.png')},
                    {img:require('../assets/cy/3.png')},
                    {img:require('../assets/cy/4.png')},
                    {img:require('../assets/cy/5.png')},
                    {img:require('../assets/cy/6.png')},
                    {img:require('../assets/cy/7.png')},
                    {img:require('../assets/cy/8.png')},
                    {img:require('../assets/cy/9.png')},
                    {img:require('../assets/cy/10.png')},
                    {img:require('../assets/cy/11.png')},
                    {img:require('../assets/cy/12.png')},
                    {img:require('../assets/cy/13.png')},
                    {img:require('../assets/cy/14.png')},
                    {img:require('../assets/cy/15.png')},
                    {img:require('../assets/cy/16.png')},
                    {img:require('../assets/cy/17.png')},
                    {img:require('../assets/cy/18.png')}
                ],
                select:0,
                mList:[],
                syList:[
                    {title:'江苏君安新材料有限公司',con:'江苏君安新材料有限公司致力于个性化家电面板材料的研发与制造，是盐城市重点骨干企业，获东台市“政府特别奖”称号，年产值达20亿元以上。产品广泛应用于冰箱、洗衣机、微波炉、液... ...'},
                    {title:'宁波泰立电子有限公司',con:'宁波泰立电子有限公司成立于2003年，拥有近20000平方米的生产基地和先进的设备技术，为国家高新技术企业，列入宁波市高成长企业培育名录，主要从事5G、4G用滤波器等通信设... ...'}
                ],
                navList:[
                    '大宗商品运营与管理',
                    '实业',
                    '投资',
                    '建筑服务业'
                ],
                info:{
                    img:require('../assets/cy/ban.png'),
                    text0:'产业布局',
                    text1:'君行正道  安积德义'
                }
            }
        },
        components:{banComponent,footComponent,diaComponent,mapComponent,btnComponent,diasyComponent,diatzComponent,diajzComponent},
       mounted(){
           this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
           window.pageYOffset=this.scrollbar.scrollTop
           this.scrollbar.addListener(() => {
               $(".allImg div").each(function() {
                   var _this = $(this);
                   if ($(window).scrollTop() >= $(this).offset().top - $(window).height() + 500)
                   {
                       _this.addClass('show');
                   }else{
                       _this.removeClass('show');
                   }
               });
               window.pageYOffset=this.scrollbar.scrollTop
           });
           if(this.$route.query.index!==undefined){
               this.change(parseInt(this.$route.query.index-1))
           }else if(this.$route.query.index2!==undefined){
               this.change(parseInt(this.$route.query.index2))
           }else {
               this.change(0)
           }
       },
        methods:{
            showMore(){
                if(this.page<=this.totalPage){
                    const url = `${getProductsUrl(this.$i18n.locale,this.id,6,this.page++)}`
                    this.$axios.get(url).then(res => {
                        this.mList=this.mList.concat(res.data.proarr)
                    })
                }else{
                    this.$notify({
                        title: '提示',
                        message: '已经加载全部了',
                        offset: 100
                    });
                }
            },
            change(n){
                this.select=n

                // this.info.img=this.imgList2[n].url
                if(n===0){
                    if(this.$i18n.locale==='en'){
                        this.getProducts('48')
                    }else{
                        this.getProducts('43')
                    }
                    this.info.img=require('../assets/cy/ban.png')
                }else if(n===1){
                    if(this.$i18n.locale==='en'){
                        this.getProducts('49')
                    }else{
                        this.getProducts('44')
                    }
                    this.info.img=require('../assets/cy/sy.jpg')
                }else if(n===2){
                    if(this.$i18n.locale==='en'){
                        this.getProducts('50')
                    }else{
                        this.getProducts('45')
                    }
                    this.info.img=require('../assets/cy/tz.jpg')
                }else{
                    if(this.$i18n.locale==='en'){
                        this.getProducts('51')
                    }else{
                        this.getProducts('46')
                    }
                    this.info.img=require('../assets/cy/jz.jpg')
                }
            },
            getProducts(id){
                this.id=id
                this.page=2
                const url = `${getProductsUrl(this.$i18n.locale,id,6,1)}`
                this.$axios.get(url).then(res => {
                    this.mList=res.data.proarr
                    this.totalPage=res.data.pagershow.totalPagers
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    .banner{
        width:100%;
        position: relative;
        height:100vh;
        overflow: hidden;
        img{
            width:100%;
            height:100%;
            object-fit: cover;
            display: block;
        }
        .text{
            position: absolute;
            left:10%;
            width:70%;
            top:40%;
            color:white;
            p:nth-child(1){
                font-size: 50px;
                font-weight: bold;
            }
            p:nth-child(2){
                font-family: normal;
                font-weight: lighter;
                margin-top: 40px;
                line-height: 30px;
                font-size: 14px;
            }
        }
        .scr{
            width:10%;
            position: absolute;
            left:45%;
            bottom:0;
            z-index: 1000;
            height:120px;
            text-align: center;
            text-transform: uppercase;
            display: flex;
            flex-direction: column;
            justify-content: center;
            span:nth-child(1){
                color:white;
                padding-bottom: 10px;
                font-size: 12px;
            }
            span:nth-child(2){
                width:1px;
                height:100px;
                background-color: rgba(255,255,255,.2);
                position: relative;
                margin-left: 50%;
            }
            span:nth-child(2)::before{
                content:'';
                display: inline-block;
                width:1px;
                height:20px;
                position: absolute;
                top:30%;
                left:0;
                animation: runa 2s infinite ease;
                background-color: white;
            }
            @keyframes runa {
                from{
                    top:0;
                }
                to{
                    top:100%;
                }
            }
        }

    }
    .main{
        width:100%;
        .nav{
            width:100%;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content:center;
            padding: 1px 0;
            border-bottom: 1px solid rgba(0,0,0,.2);
            span{
                display: inline-block;
                padding: 15px 0;
                width:200px;
                cursor: pointer;
                transition: all 2s;
                font-size: 15px;
                text-align: center;
            }
            span:hover{
                background-color: #0068B7;
                color:white;
            }
            .showLine{
                background-color: #0068B7;
                color:white;
            }
        }
        .enNav{
            span{
                width:300px;
            }
        }
    }
    .all{
        width:100%;
       .one{
           width:100%;
           .gy{
               width:1280px;
               margin:80px auto;
               display: flex;
               flex-direction: row;
               img{
                   transition: all 1s;
                   cursor: pointer;
               }
               img:hover{
                   transform: scale(0.95);
               }
               .right{
                   margin-left: 3%;
                   p{
                       font-size: 30px;
                       font-weight: bold;
                       padding-bottom: 15px;
                       border-bottom: 1px solid rgba(0,0,0,.1);
                       position: relative;
                   }
                   p::before{
                       position: absolute;
                       left:0;
                       bottom:0;
                       content:'';
                       display: inline-block;
                       height:1px;
                       width:25%;
                       background-color: #3B95FF;
                   }
                   .a{
                       margin-top: 20px;
                   }
               }
           }
           .module{
               width:100%;
               background-color: #F7F7F7;
               padding: 60px 0;
               .title{
                   font-size: 30px;
                   font-weight: bold;
                   padding-bottom: 30px;
                   border-bottom: 1px solid rgba(130, 130, 130, .3);
                   position: relative;
                   text-align: center;
                   width:30%;
                   margin-left: 35%;
               }
               .title::before{
                   position: absolute;
                   left:40%;
                   bottom:0;
                   content:'';
                   display: inline-block;
                   height:1px;
                   width:20%;
                   background-color: #3B95FF;
               }
               .content{
                   width:1280px;
                   margin: 30px auto;
                   display: flex;
                   flex-direction: row;
                   flex-wrap: wrap;
                   justify-content: space-between;
                   .item{
                       width:45%;
                       background-color: white;
                       padding: 40px 20px;
                       margin-top: 60px;
                       cursor: pointer;
                       transition: all 2s;
                       a{
                           color:black;
                           transition: all 2s;
                       }
                       p:nth-child(1){
                           font-size: 22px;
                           font-weight: bold;
                       }
                       p:nth-child(2){
                           font-size: 15px;
                           line-height: 40px;
                           margin-top: 20px;
                       }
                       span{
                           display: inline-block;
                           background-color: #E0E0E0;
                           padding:6px 20px;
                           font-size: 14px;
                           margin-top: 30px;
                       }
                   }
                   .item:hover{
                    background-color: #0068B7;
                       a{
                           color:white;
                       }
                       span{
                           color:#343434;
                       }
                   }
               }
           }
           .map{
               width:100%;
               background-color: #0068B7;
               padding: 60px 0;
               .m{
                   width:1280px;
                   margin: 0 auto;
                   p{
                       color:white;
                       font-family: normal;
                       font-weight: lighter;
                       text-align: center;
                       margin-top: 30px;
                       line-height: 30px;
                       font-size: 14px;
                   }
               }
               img{
                   display: none;
               }
           }
           .table{
               width:100%;
               background-color: #F7F7F7;
               text-align: center;
               padding: 80px 0;
           }
           .company{
               width:100%;
               padding: 60px 0;
               .title{
                   font-size: 30px;
                   font-weight: bold;
                   padding-bottom: 30px;
                   border-bottom: 1px solid rgba(130, 130, 130, .3);
                   position: relative;
                   text-align: center;
                   width:30%;
                   margin-left: 35%;
               }
               .title::before{
                   position: absolute;
                   left:40%;
                   bottom:0;
                   content:'';
                   display: inline-block;
                   height:1px;
                   width:20%;
                   background-color: #3B95FF;
               }
               .allImg{
                   width:1280px;
                   margin: 30px auto;
                   display: flex;
                   flex-direction: row;
                   flex-wrap: wrap;
                   justify-content: space-between;
                   .item{
                       width:15%;
                       height:60px;
                       text-align: center;
                       border: 1px solid #DFDFDF;
                       padding: 30px 0;
                       margin-top: 30px;
                       cursor: pointer;
                       overflow: hidden;
                       opacity: 0;
                       transition: all 2s;
                       img{
                           height:50px;
                           transition: all 2s;
                       }
                   }
                   .item:hover{
                       img{
                           transform: scale(1.05);
                       }
                   }
                   .show{
                       opacity: 1;
                   }
               }
           }
       }
        .two{
            width:100%;
            .fir{
                width:1280px;
                margin: 60px auto;
                display: flex;
                flex-direction: row;
                img{
                    transition: all 1s;
                    cursor: pointer;
                }
                img:hover{
                    transform: scale(0.95);
                }
                .right{
                    margin-left: 3%;
                    p:nth-child(1){
                        font-size: 30px;
                        font-weight: bold;
                        padding-bottom: 15px;
                        border-bottom: 1px solid rgba(0,0,0,.1);
                        position: relative;
                    }
                    p:nth-child(1)::before{
                        position: absolute;
                        left:0;
                        bottom:0;
                        content:'';
                        display: inline-block;
                        height:1px;
                        width:25%;
                        background-color: #3B95FF;
                    }
                    p:nth-child(2){
                        margin-top: 20px;
                        font-size: 14px;
                        line-height: 30px;
                    }
                    .a{
                        margin-top: 20px;
                    }
                }
            }
            .module{
                width:100%;
                background-color: #F7F7F7;
                padding: 60px 0;
                .title{
                    font-size: 30px;
                    font-weight: bold;
                    padding-bottom: 30px;
                    border-bottom: 1px solid rgba(130, 130, 130, .3);
                    position: relative;
                    text-align: center;
                    width:30%;
                    margin-left: 35%;
                    text-transform: capitalize;
                }
                .title::before{
                    position: absolute;
                    left:40%;
                    bottom:0;
                    content:'';
                    display: inline-block;
                    height:1px;
                    width:20%;
                    background-color: #3B95FF;
                }
                .content{
                    width:1280px;
                    margin: 30px auto;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .item{
                        width:45%;
                        background-color: white;
                        padding: 40px 20px;
                        margin-top: 60px;
                        cursor: pointer;
                        transition: all 2s;
                        a{
                            color:black;
                            transition: all 2s;
                        }
                        p:nth-child(1){
                            font-size: 22px;
                            font-weight: bold;
                        }
                        p:nth-child(2){
                            font-size: 15px;
                            line-height: 40px;
                            margin-top: 20px;
                        }
                        span{
                            display: inline-block;
                            background-color: #E0E0E0;
                            padding:6px 20px;
                            font-size: 14px;
                            margin-top: 30px;
                        }
                    }
                    .item:hover{
                        background-color: #0068B7;
                        a{
                            color:white;
                        }
                        span{
                            color:#343434;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width:1280px){
        .all{
            .one{
                .gy{
                    width:1200px;
                }
                .module{
                    .content{
                        width:1200px;
                    }
                }
                .company{
                    .allImg{
                        width:1200px;
                    }
                }
            }
        }
    }
    @media screen and (max-width:1279px){
        .banner{
            .text{
                width:90%;
                top:20%;
                left:5%;
            }
        }
        .main{
            .nav{
                flex-wrap: wrap;
                span{
                    width:100%;
                    padding: 15px 0;
                    text-align: center;
                }
            }
        }
        .all{
            .one{
                .gy{
                    width:95%;
                    flex-direction: column;
                    margin-bottom: 20px;
                    img{
                        height:200px;
                        object-fit: cover;
                    }
                    .right{
                        margin-left: 0;
                        margin-top: 30px;
                        p{
                            font-size: 25px;
                        }
                    }
                }
                .module{
                    padding: 30px 0;
                    .title{
                        width:80%;
                        margin-left: 10%;
                        font-size: 22px;
                    }
                    .content{
                        width:95%;
                        margin-left: 2.5%;
                        .item{
                            width:100%;
                        }
                    }
                }
                .map{
                  padding: 0;
                   .m{
                       display: none;
                   }
                    img{
                        width:90%;
                        object-fit: contain;
                        display: block;
                        margin-left: 5%;
                    }
                }
                .table{
                    padding: 20px 0;
                    img{
                        width:90%;
                        height:200px;
                        object-fit: contain;
                    }
                }
                .company{
                    padding: 20px 0;
                    .title{
                        width:80%;
                        margin-left: 10%;
                        font-size: 22px;
                    }
                    .allImg{
                        width:95%;
                        margin-left: 2.5%;
                        .item{
                            width:30%;
                        }
                    }
                }
            }
            .two{
                .fir{
                    width:95%;
                    margin-left: 2.5%;
                    flex-direction: column;
                    img{
                        height:200px;
                        width:100%;
                        object-fit: contain;
                    }
                     .right{
                        p:nth-child(1){
                            font-size: 22px;
                            margin-top: 20px;
                        }
                    }
                }
                .module{
                    .title{
                        width: 80%;
                        margin-left: 10%;
                        font-size: 22px;
                    }
                    .content{
                        width:95%;
                        .item{
                            width:100%;
                        }
                    }
                }
            }
        }
    }
}
</style>